/**
 * @type2x/i18n
 *
 * Локализация интерфейса на русском и английском (UX-14).
 * Пакет не содержит учебного контента: словари живут в @type2x/corpora.
 */

import type { LanguageCode } from '@type2x/shared-contracts';

import { EN_MESSAGES } from './en.js';
import { RU_MESSAGES } from './ru.js';
import type { Locale, Messages, Translate } from './types.js';

export type { Locale, MessageKey, Messages, Translate } from './types.js';
export { EN_MESSAGES } from './en.js';
export { RU_MESSAGES } from './ru.js';

const LOCALES: Readonly<Record<LanguageCode, Locale>> = {
  ru: { code: 'ru', messages: RU_MESSAGES },
  en: { code: 'en', messages: EN_MESSAGES },
};

/** Локаль по коду языка. */
export function getLocale(code: LanguageCode): Locale {
  return LOCALES[code];
}

/**
 * Создаёт функцию перевода.
 *
 * Отсутствующий ключ возвращается как есть: это заметно в интерфейсе и
 * ловится тестом на полноту словарей, но не роняет экран пользователю.
 */
export function createTranslate(messages: Messages): Translate {
  return (key, values) => {
    const template = messages[key] ?? key;
    if (values === undefined) return template;

    return template.replace(/\{(\w+)\}/g, (match: string, name: string) =>
      name in values ? String(values[name]) : match,
    );
  };
}

/** Все ключи, объявленные в русской локали. Она считается эталонной. */
export function messageKeys(): readonly string[] {
  return Object.keys(RU_MESSAGES);
}
